export default {
  findTeam: (state) => (id) => state.teams.find((t) => t.id === id)
}
